// src/slices/product/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getAllProducts, getOneProduct, createProduct } from "./thunk";

const initialState = {
  products: [],
  product: null,

  loading: false,
  createLoading: false,

  error: null
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // =========================
      // GET ALL PRODUCTS
      // =========================
      .addCase(getAllProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload?.data || action.payload;
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // =========================
      // GET ONE PRODUCT
      // =========================
      .addCase(getOneProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOneProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload?.data || null;
      })
      .addCase(getOneProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // =========================
      // CREATE PRODUCT
      // =========================
      .addCase(createProduct.pending, (state) => {
        state.createLoading = true;
        state.error = null;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.createLoading = false;

        const newProduct = action.payload?.data || action.payload;

        state.products.unshift(newProduct);
      })
      .addCase(createProduct.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
      });
  }
});

export default productSlice.reducer;
